import { render, staticRenderFns } from "./TeamLineupSummary.vue?vue&type=template&id=2e3e4142&"
import script from "./TeamLineupSummary.vue?vue&type=script&lang=ts&"
export * from "./TeamLineupSummary.vue?vue&type=script&lang=ts&"
import style0 from "./TeamLineupSummary.vue?vue&type=style&index=0&id=2e3e4142&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports